
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type VersionInfo = { version: string };

export function useAutoReloadOnNewVersion(forceReloadOnEveryNav = false) {
  const location = useLocation();

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?cb=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return;
        const data: VersionInfo = await res.json();

        const currentVersion = localStorage.getItem('app_version');
        if (!currentVersion) {
          localStorage.setItem('app_version', data.version);
        } else if (data.version !== currentVersion) {
          localStorage.setItem('app_version', data.version);
          sessionStorage.setItem('reloaded', 'true');
          window.location.replace(window.location.href);
          return;
        }

        if (forceReloadOnEveryNav && !sessionStorage.getItem('reloaded')) {
          sessionStorage.setItem('reloaded', 'true');
          window.location.replace(window.location.href);
        } else {
          sessionStorage.removeItem('reloaded');
        }
      } catch {
        // Ignore errors
      }
    };

    checkVersion();
  }, [location, forceReloadOnEveryNav]);
}
